import React, { Component } from 'react'
import Helmet from 'react-helmet'

import SectionMain from '@/section-main'
import SectionDesigned from '@/section-designed'
import SectionBeautyPageants from '@/section-beauty-pageants'
import SectionTailored from '@/section-tailored'
import SectionGlobalPlatform from '@/section-global-platform'
import SectionGotInterested from '@/section-got-interested'

import shareImg from './images/index.jpg'

class Homepage extends Component {
  render() {
    const { data } = this.props

    return (
      <div>
        <Helmet>
          <title>Next Miss</title>
          <meta property="og:title" content="Next level digital tools for your beauty pageant" />
          <meta property="og:description" content="Bring your casting, voting and judge rating to the digital age today!" />
          <meta property="og:image" content={`https://nextmiss.com${shareImg}`} />
          <meta property="og:url" content="https://nextmiss.com/" />
          <meta property="og:image:alt" content="Next Miss" />
        </Helmet>
        <SectionMain data={data} />
        <SectionDesigned gray />
        <SectionBeautyPageants data={data} />
        <SectionTailored gray />
        <SectionGlobalPlatform />
        <SectionGotInterested />
      </div>
    )
  }
}

export default Homepage

export const query = graphql`
  query IndexQuery {
    pageants1: imageSharp(id: { regex: "/pageants1/" }) {
      sizes(maxWidth: 197) {
        ...GatsbyImageSharpSizes
      }
    }
    pageants2: imageSharp(id: { regex: "/pageants2/" }) {
      sizes(maxWidth: 197) {
        ...GatsbyImageSharpSizes
      }
    }
    pageants3: imageSharp(id: { regex: "/pageants3/" }) {
      sizes(maxWidth: 197) {
        ...GatsbyImageSharpSizes
      }
    }
    pageants4: imageSharp(id: { regex: "/pageants4/" }) {
      sizes(maxWidth: 197) {
        ...GatsbyImageSharpSizes
      }
    }
    avatar1: imageSharp(id: { regex: "/avatar1/" }) {
      sizes(maxWidth: 60) {
        ...GatsbyImageSharpSizes
      }
    }
    avatar2: imageSharp(id: { regex: "/avatar2/" }) {
      sizes(maxWidth: 60) {
        ...GatsbyImageSharpSizes
      }
    }
    avatar3: imageSharp(id: { regex: "/avatar3/" }) {
      sizes(maxWidth: 60) {
        ...GatsbyImageSharpSizes
      }
    }
    avatar4: imageSharp(id: { regex: "/avatar4/" }) {
      sizes(maxWidth: 60) {
        ...GatsbyImageSharpSizes
      }
    }
    landerSlide0: imageSharp(id: { regex: "/landerSlide0/" }) {
      sizes(maxWidth: 1020) {
        ...GatsbyImageSharpSizes
      }
    }
    landerSlide1: imageSharp(id: { regex: "/landerSlide1/" }) {
      sizes(maxWidth: 1020) {
        ...GatsbyImageSharpSizes
      }
    }
    landerSlide2: imageSharp(id: { regex: "/landerSlide2/" }) {
      sizes(maxWidth: 1020) {
        ...GatsbyImageSharpSizes
      }
    }
    landerSlide3: imageSharp(id: { regex: "/landerSlide3/" }) {
      sizes(maxWidth: 1020) {
        ...GatsbyImageSharpSizes
      }
    }
    landerSlide4: imageSharp(id: { regex: "/landerSlide4/" }) {
      sizes(maxWidth: 1020) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/index.js